import type { JSX } from 'react';
import { AppProviders } from './providers';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AppRouterProvider } from './router';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { AuthGate } from '@/features/auth/AuthGate';
import { ErrorBoundary } from '@/components/blocks/feedback';
import { SyncStatusNotifier } from '@/components/blocks/feedback/SyncStatusNotifier';
import { RecoveredErrorIndicator } from '@/components/blocks/feedback/RecoveredErrorIndicator';
import { errorLogger } from '@/lib/errorLogger';
import { GlobalModal } from '@/components';
import { SyncScheduler } from '@/data/sync/SyncScheduler';

export function App(): JSX.Element {
  return (
    <ErrorBoundary
      enableDiagnostics={true}
      onError={(error, errorInfo) => {
        errorLogger.logError(error, errorInfo, {
          category: 'react',
          retryable: true,
        });
        errorLogger.capturePerformanceMetrics(
          errorInfo?.componentStack?.split('\n')[0]?.trim() || 'unknown'
        );
      }}
    >
      <AppProviders>
        <TooltipProvider>
          <AuthProvider>
            <AuthGate>
              <AppRouterProvider />
              <GlobalModal />
              <SyncScheduler />
              <SyncStatusNotifier />
              <RecoveredErrorIndicator />
              <Toaster />
            </AuthGate>
          </AuthProvider>
        </TooltipProvider>
      </AppProviders>
    </ErrorBoundary>
  );
}
